import styled from "@emotion/styled";
import { Box } from "@mui/material";
import PropTypes from "prop-types";
import type { FC } from "react";
import { useEffect } from "react";
import BenefitsSection from "src/components/home/BenefitsSection";
import CallSection from "src/components/home/CallSection";
import Faq from "src/components/home/Faq";
import HomeHeroSection from "src/components/home/HomeHeroSection";
import Steps from "src/components/home/Steps";
import Layout from "src/components/shared/Layout";
import bgImage from "../assets/images/bg.png";
import gtm from "../lib/gtm";

interface HomeProps {
  openMenu?: string;
}

const BGImage = styled("img")(() => ({
  position: "absolute",
  right: 0,
  top: -250,
  filter: "saturate(3)",
}));

const Home: FC<HomeProps> = () => {
  useEffect(() => {
    gtm.push({ event: "page_view" });
  }, []);

  return (
    <Layout>
      <Box sx={{ position: "relative", overflow: "hidden" }}>
        <BGImage src={bgImage} alt="" />
        <Box id="home-hero">
          <HomeHeroSection />
        </Box>
        <Box id="benefits-section">
          <BenefitsSection />
        </Box>
        <Box id="steps-section">
          <Steps />
        </Box>
        <Box id="faq-section">
          <Faq />
        </Box>
        <CallSection />
      </Box>
    </Layout>
  );
};

Home.propTypes = {
  openMenu: PropTypes.string,
};

export default Home;
